import { PageComponentEntity, CtaEntity } from "@shared/services/event_tracking/entities";
import { EventTracking } from "@shared/services/event_tracking/events";
import MenuStore from "@retailer/svelte/stores/MenuStore";
import FeatureMenuStore from "@retailer/svelte/stores/FeatureMenuStore";
import MenuItemStore from "@retailer/svelte/stores/MenuItemStore";
import DemoSignupModal from "@shared/svelte/Components/Layout/DemoHeader/DemoSignupModal.svelte";
import _ from "lodash";

const { trackClick } = EventTracking;

export function href(item) {
  if (window.location.href.includes("/demo/")) {
    return "#";
  }
  if (item.url) {
    return item.url;
  }
  if (item.subcategory_id) {
    return `/product_listing?subcategory=${item.subcategory_id}`;
  }
  if (item.category_id) {
    return `/product_listing?category=${item.category_id}`;
  }
  if (item.product_type_id) {
    return `/product_listing?type=${item.product_type_id}`;
  }
  if (item.distributor_id) {
    return `/product_listing?distributors=${item.distributor_id}`;
  }
}

export function getParams(item) {
  if (item.subcategory_id) {
    return { subcategory: item.subcategory_id };
  }
  if (item.category_id) {
    return { category: item.category_id };
  }
  if (item.product_type_id) {
    return { type: item.product_type_id };
  }
  if (item.distributor_id) {
    return { distributors: item.distributor_id };
  }
}

export function setupDistributorFeatures() {
  let featureMenus;

  FeatureMenuStore.update(n => {
    featureMenus = n;
    return n;
  });

  return featureMenus.find(n => n.distributor_feature);
}

let setupMenusCache;

export function setupMenus(mobile = false) {
  let menusRes = [];
  MenuStore.update(menus => {
    let featureMenus;
    FeatureMenuStore.update(n => {
      featureMenus = n;
      return n;
    });

    MenuItemStore.update(items => {
      for (let originalMenu of menus) {
        let menu = { ...originalMenu };
        menusRes.push(menu);
        menu.items = items.filter(item => item.navigation_menu_id == menu.id);
        menu.items.sort((a, b) => a.position - b.position);
        menu.menus = [];
      }
      return items;
    });

    let removeMenus = [];
    for (let menu of menusRes) {
      if (!menu.navigation_menu_id) {
        continue;
      }
      var parentMenu = menusRes.find(m => menu.navigation_menu_id == m.id);
      parentMenu.menus.push(menu);
      parentMenu.menus.sort((a, b) => a.position - b.position);
      removeMenus.push(menu);
    }

    let menu;
    while ((menu = removeMenus.pop())) {
      var idx = menusRes.indexOf(menu);
      menusRes.splice(idx, 1);
    }

    if (menusRes[0]) {
      for (let menu of menusRes[0].menus) {
        if (mobile) {
          for (let submenu of menu.menus) {
            for (let subitem of submenu.items) {
              subitem.mobilePosition = submenu.position * 100 + subitem.position;
            }
          }
          menu.items = menu.menus
            .map(n => n.items)
            .flat()
            .filter(n => n.show_in_mobile);
        }
        let featureMenu = featureMenus.find(n => n.navigation_menu_id == menu.id);
        if (featureMenu) {
          menu.menus.push(featureMenu);
        }
      }
    }
    return menus;
  });
  return menusRes;
}

const getTrackingParams = args => {
  let menuData = _.pick(args.menu || {}, [
    "distributor_feature",
    "feature",
    "label",
    "header",
    "id",
    "items",
    "subitems",
    "menus",
    "navigation_menu_id",
    "position",
  ]);
  if (menuData.header) {
    menuData.header = _.pick(menuData.header, [
      "category_id",
      "id",
      "label",
      "navigation_menu_id",
      "navigation_menu_item_id",
      "parent_position",
      "product_type_id",
      "subcategory_id",
      "show_in_mobile",
      "url",
    ]);
  }
  let itemData = _.pick(args.item || {}, [
    "category_id",
    "id",
    "label",
    "navigation_menu_id",
    "navigation_menu_item_id",
    "parent_position",
    "position",
    "product_type_id",
    "show_in_mobile",
    "subcategory_id",
    "url",
    "distributor_id",
    "storefront",
  ]);
  let entities = [
    new PageComponentEntity({
      component: "menu",
      data: {
        menu: menuData,
        item: itemData,
      },
    }),
  ];

  if (args.cta) {
    entities.push(new CtaEntity(args.cta));
  }
  return entities;
};

export const handleClick = (e, args) => {
  const trackingParams = getTrackingParams(args);
  if (trackingParams) {
    trackClick(null, trackingParams);
  }

  if (window.location.href.includes("/demo/")) {
    window.svelteModal(DemoSignupModal);
    e.preventDefault();
    return false;
  }
  return true;
};

let helpers = { href, setupMenus, setupDistributorFeatures, handleClick };
export default helpers;
